/**
 * Gruppen der Aufgabenseite (12.10.2026, `lib/aufgabenOrdnung.ts`): oben „Kommende
 * Termine" und „Überfällig", darunter Themen oder Kunden. Alle Gruppen sind gleich
 * gebaut und klappbar; die beiden oben tragen nur einen kleinen Punkt am Titel — die
 * Seite soll ruhig bleiben (Benjamin, 12.10.2026). Aufgeklappt eine Liste, keine
 * Kacheln. Jede Karte trägt ihren Grund als leise Zeile — „Termin morgen",
 * „20 Tage überfällig" —, damit niemand raten muss, warum sie wo steht.
 */
import type { Gruppe } from "../../lib/aufgabenOrdnung";
import type { Notiz } from "../../lib/notizen";
import NotizKarte from "./NotizKarte";

function Zeile({ n, gruppe, onKunde }: { n: Notiz; gruppe: string; onKunde: (id: string) => void }) {
  const o = n.ordnung;
  return (
    <div className={"nz-zeile-aufgabe" + (o?.lage ? ` is-${o.lage}` : "")}>
      {o?.grund && <span className="nz-grund">{o.grund}</span>}
      <NotizKarte notiz={n} gruppe={gruppe} onKunde={onKunde} />
    </div>
  );
}

type Props = {
  gruppen: Gruppe[];
  offen: (g: Gruppe) => boolean;
  umschalten: (g: Gruppe) => void;
  zaehle: (g: Gruppe) => number;
  onKunde: (id: string) => void;
};

export default function AufgabenGruppen({ gruppen, offen, umschalten, zaehle, onKunde }: Props) {
  return (
    <div className="nz-kundenliste">
      {gruppen.map((g) => {
        const auf = offen(g);
        // Unter einem Kunden ist der Kunde schon die Überschrift — die Karte nennt ihn dann nicht noch einmal.
        const titelAufKarte = g.schluessel.startsWith("t:") || g.lage ? "" : g.titel;
        return (
          <section key={g.schluessel} aria-label={g.titel}
            className={"nz-kunde" + (g.lage ? ` nz-lage is-${g.lage}` : "") + (auf ? " is-offen" : "")}>
            <div className="nz-kunde-zeile">
              <h2 className="nz-kunde-kopf">
                <button type="button" aria-expanded={auf} onClick={() => umschalten(g)}>
                  <span className="nz-kunde-pfeil" aria-hidden="true">›</span>
                  <span className="nz-kunde-name">{g.titel}</span>
                  <span className="nz-kunde-zahl">{zaehle(g)}</span>
                </button>
              </h2>
              {g.kunde && (
                <button type="button" className="nz-kunde-daten" title="Kundendaten öffnen" aria-label={`Kundendaten ${g.titel}`}
                  onClick={() => onKunde(g.kunde as string)}>
                  Kunde
                </button>
              )}
            </div>
            {auf && (
              <div className="nz-kunde-aufgaben">
                {g.notizen.map((n) => <Zeile key={n.id} n={n} gruppe={titelAufKarte} onKunde={onKunde} />)}
              </div>
            )}
          </section>
        );
      })}
    </div>
  );
}
